import { userConstants } from "../constants";

export function changePassword(state = {}, action) {
  switch (action.type) {
    case userConstants.CHANGE_PASSWORD_REQUEST:
      return {};
    case userConstants.CHANGE_PASSWORD_SUCCESS:
      const { error } = action.payload.response.data;
      if (error) {
        return {
          changed: false,
          error,
          submitted: false
        };
      }
      return {
        changed: true
      };
    case userConstants.CHANGE_PASSWORD_FAILURE:
      return {
        changed: false,
        error: "Password change request was unsuccessful."
      };
    default:
      return state;
  }
}

export default changePassword;
